// eslint-disable-next-line @nx/enforce-module-boundaries
import { ObjectValues } from '@lx/shared/utils-ts';

export const COMPANIES = {
  ALPADIA: 'alpadia',
  ESL: 'esl',
  KAPLAN: 'kaplan',
  POSITIVELY_LANGUAGES: 'positively-languages',
} as const;

export type Company = ObjectValues<typeof COMPANIES>;
export type CompanyKey = keyof typeof COMPANIES;
